class ErrorUnauthorized extends Error {
  message = 'You should be an authorized user';
}
export default ErrorUnauthorized;
